import { useEffect, useState } from "react";
import { ref, get, onValue } from "firebase/database";
import { rtdb } from "../../firebase.config";

export default function useProperty(ownerId, id) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ownerId || !id) return;
    const node = ref(rtdb, `properties/${ownerId}/${id}`);

    get(node)
      .then((s) => setData(s.val() || null))
      .catch(setError)
      .finally(() => setLoading(false));

    const unsub = onValue(node, (s) => setData(s.val() || null), setError);
    return () => unsub();
  }, [ownerId, id]);

  return { data, loading, error };
}
